module.exports = __webpack_public_path__ + "media/images/game_icon/th/VG1003-2a678785f076b77680d609c2c261332f.png";